<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
       />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@//modules/report/document'

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => 
  ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Informe de Comentarios',
      routes: ["Informes", "Informe de Comentarios"]
    },
    model: {
      search: {
        filters: {
          fromDate: null,
          toDate: null,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
    return [
      {
          name: 'fromDate',
          component: 'custom-date-picker',
          label: 'Fecha Desde',
          placeholder: 'Seleccionar Fecha Desde',
          error: "Fecha Desde es requerida.",
          validations: "required",
          class: 'col-md-3',
          classContainer: 'date-width-container',
          maxDate: new Date(),
          value: this.model.search.filters.fromDate,
      },
      {
          name: 'toDate',
          component: 'custom-date-picker',
          label: 'Fecha Hasta',
          placeholder: 'Seleccionar Fecha Hasta',
          error: "Fecha Hasta es requerida.",
          validations: "required",
          class: 'col-md-3',
          classContainer: 'date-width-container',
          maxDate: new Date(),
          value: this.model.search.filters.toDate,
      },
    ]},
  },
  async mounted() {
  },
  methods: {
    hasValue(param){
      return param !== null && param !== undefined;
    },
    async onHandlerSearch() {
      this.process();
    },
    async process() {
      if(!this.hasValue(this.model.search.filters.fromDate) || 
        !this.hasValue(this.model.search.filters.toDate)) {
        return;
      }

      if(this.model.search.filters.fromDate > this.model.search.filters.toDate) {
        this.ShowToast('Atención', 'La Fecha Hasta no puede ser menor a la Fecha Desde.', 'error')
        return;
      }
      
      await ReportServices.getReport('reportcomments', {
        fromDate : this.model.search.filters.fromDate,
        toDate : this.model.search.filters.toDate,
        })
        .then(res => DocumentServices.Download(res.data));
    },
  },
}
</script>